import React from 'react';
import { FormattedMessage } from 'react-intl';
import {
  DatedEvidence,
  FormCustomField,
  FormDateTimeField,
  FormPanel,
  FormSelect,
  FormTextArea,
  FormTextField,
  useStaticListSource,
  useFormSelector,
} from '@eas/common-web';
import { EsFileReturnLog } from '@models';

const stateLabel: Record<string, string> = {
  IN_PROGRESS: 'Probíhá',
  INTERRUPTED: 'Přerušeno',
  COMPLETED: 'Dokončeno',
  COMPLETED_WITH_FAILURES: 'Dokončeno s chybami',
  FAILED: 'Selhalo',
};

const stateOptions = Object.entries(stateLabel).map(([id, label]) => ({
  id,
  name: label,
  label,
}));

export function Fields() {
  const stateSource = useStaticListSource(stateOptions);
  const { failures } = useFormSelector((data: EsFileReturnLog) => ({
    failures: data?.failures ?? [],
  }));

  return (
    <FormPanel
      label={<FormattedMessage id="ES__ES_FILE_RETURN_LOG__DETAIL__PANEL__GENERAL" defaultMessage="Obecné" />}
      expandable={false}
    >
      <FormTextField name="description" label={<FormattedMessage id="ES__ES_FILE_RETURN_LOG__DETAIL__FIELD__DESCRIPTION" defaultMessage="Popis" />} />
      <FormSelect
        name="state"
        source={stateSource}
        label={<FormattedMessage id="ES__ES_FILE_RETURN_LOG__DETAIL__FIELD__STATE" defaultMessage="Stav" />}
        disabled={true}
        valueIsId={true}
      />
      <FormTextField name="processedCount" label={<FormattedMessage id="ES__ES_FILE_RETURN_LOG__DETAIL__FIELD__PROCESSED" defaultMessage="Zpracováno" />} />
      <FormTextField name="totalCount" label={<FormattedMessage id="ES__ES_FILE_RETURN_LOG__DETAIL__FIELD__TOTAL" defaultMessage="Celkem" />} />
      <FormTextField name="successCount" label={<FormattedMessage id="ES__ES_FILE_RETURN_LOG__DETAIL__FIELD__SUCCESS" defaultMessage="Úspěšně předáno" />} />
      <FormTextField name="failedCount" label={<FormattedMessage id="ES__ES_FILE_RETURN_LOG__DETAIL__FIELD__FAILED" defaultMessage="Selhalo" />} />
      <FormDateTimeField name="executionStart" label={<FormattedMessage id="ES__ES_FILE_RETURN_LOG__DETAIL__FIELD__EXECUTION_START" defaultMessage="Začátek" />} />
      <FormDateTimeField name="executionEnd" label={<FormattedMessage id="ES__ES_FILE_RETURN_LOG__DETAIL__FIELD__EXECUTION_END" defaultMessage="Konec" />} />
      <FormTextArea name="failureReason" label={<FormattedMessage id="ES__ES_FILE_RETURN_LOG__DETAIL__FIELD__FAILURE_REASON" defaultMessage="Důvod úplného selhání" />} />
      <FormCustomField name="failures" label={<FormattedMessage id="ES__ES_FILE_RETURN_LOG__DETAIL__FIELD__FAILURES" defaultMessage="Selhané spisy" />}>
        <div>
          {failures.length === 0 && <div>-</div>}
          {failures.map((failure, index) => (
            <div key={`${failure.id ?? 'failure'}-${index}`}>
              {(failure.number ?? failure.id) || '-'}: {failure.exceptionMessage || failure.exceptionType || '-'}
            </div>
          ))}
        </div>
      </FormCustomField>
      <DatedEvidence.FieldCreated />
      <DatedEvidence.FieldUpdated />
    </FormPanel>
  );
}
